/**
 * Link ヘッダー（RFC 8288）に rel="next" の関係が含まれるかを判定する
 */
export function hasNextLink(linkHeader: string | undefined): boolean {
  if (!linkHeader) return false;
  return /;\s*rel="?next"?/.test(linkHeader);
}
